import React from "react";
import {
  ContentLayout,
  Header,
  Cards,
  Box,
  SpaceBetween,
  Button,
  Link,
  Container,
  Spinner,
  TextContent,
  AppLayout,
} from "@cloudscape-design/components";
import { useHistory } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useMenu } from "../context/MenuContext";

export default function Home() {
  const { user, isAdmin, companyname, isAuthenticated } = useAuth();
  const { isMenuVisible } = useMenu();
  const history = useHistory();

  // Admins see everything; other users see only what their group has access to
  const canSee = (path) => isAdmin() || isMenuVisible(path);

  const getCards = () => {
    const cards = [];

    if (canSee("/boxer/execute-query")) {
      cards.push({
        name: "Chatbot",
        description: "Ask questions about your warehouse data in plain English. OpsLense queries live operational tables; DocuSense searches SOPs, policies and documents. Powered by Claude AI.",
        icon: "🤖",
        href: "/boxer/execute-query",
      });
    }

    if (canSee("/boxer/delivery-command-center")) {
      cards.push({
        name: "Live Delivery Command Center",
        description: "Real-time network-wide shipment adherence across all DCs. Monitor at-risk orders, projected EOD performance, and executive summaries as data arrives.",
        icon: "🚚",
        href: "/boxer/delivery-command-center",
      });
    }

    if (canSee("/boxer/delivery-monitoring")) {
      cards.push({
        name: "Delivery Adherence Monitoring",
        description: "Drill into DC performance, store region delivery trends and critical shipping lanes for any date range. Compare this period vs previous period with AI-generated insights.",
        icon: "🎛️",
        href: "/boxer/delivery-monitoring",
      });
    }

    if (isAdmin()) {
      cards.push({
        name: "Admin Panel",
        description: "Manage users and groups.",
        icon: "⚙️",
        href: "/admin",
      });
    }

    return cards;
  };

  const handleLaunchApplication = (link) => {
    history.push(link);
  };

  const cards = getCards();

  return (
    <div>
      <TextContent>
        <Box margin="xxl" padding="l">
          <SpaceBetween size="l">
            <div key="main-content">
              <Container header={<Header>Welcome to {companyname} SmartOps Suite</Header>}>
                <SpaceBetween size="s">
                  <Box variant="p" fontSize="body-m">
                    <strong>Boxer SmartOps</strong> is an AI-powered warehouse intelligence platform that transforms
                    raw operational data into real-time decisions — built for warehouse managers, operations leads,
                    and supply chain executives who need answers, not dashboards to dig through.
                  </Box>
                </SpaceBetween>
              </Container>
            </div>
            <div key="applications-content">
              <Container header={<Header>Applications</Header>}>
                <Cards
                  ariaLabels={{
                    itemSelectionLabel: (e, t) => `select ${t.name}`,
                    selectionGroupLabel: "Application selection"
                  }}
                  cardDefinition={{
                    header: item => (
                      <Link 
                        fontSize="heading-m" 
                        onFollow={() => handleLaunchApplication(item.href)}
                      >
                        {item.name}
                      </Link>
                    ),
                    sections: [
                      {
                        id: "description",
                        header: "Description",
                        content: item => item.description
                      },
                      {
                        id: "actions",
                        content: item => (
                          <Button 
                            variant="primary" 
                            onClick={() => handleLaunchApplication(item.href)}
                          >
                            Launch Application
                          </Button>
                        )
                      }
                    ]
                  }}
                  cardsPerRow={[
                    { cards: 1 },
                    { minWidth: 500, cards: 2 },
                    { minWidth: 800, cards: 4 }
                  ]}
                  items={cards}
                  loadingText="Loading applications"
                  empty={
                    <Box textAlign="center" color="inherit">
                      <b>No applications available</b>
                      <Box
                        padding={{ bottom: "s" }}
                        variant="p"
                        color="inherit"
                      >
                        {isAuthenticated 
                          ? "You don't have permission to access any applications. Contact your administrator for access."
                          : "No applications to display at this time."
                        }
                      </Box>
                    </Box>
                  }
                />
              </Container>
            </div>
            <div key="footer-content">
              <Container>
                <SpaceBetween size="s">
                   <Box variant="p" color="text-body-secondary">
                    🎯 100% Real Data Analysis — All metrics, insights, and recommendations are derived exclusively
                    from your operational data. No fabricated numbers, no generic benchmarks.
                  </Box>
                </SpaceBetween>
              </Container>
            </div>
          </SpaceBetween>
        </Box>
      </TextContent>
    </div>
  );
  
  // return (
  //   <ContentLayout
  //     header={
  //       <Header
  //         variant="h1"
  //         description={`Welcome back, ${user?.username}. Select a module below.`}
  //       >
  //         {companyname} SmartOps Dashboard
  //       </Header>
  //     }
  //   >
  //     <SpaceBetween size="l">
  //       {cards.length === 0 ? (
  //         <Box textAlign="center" color="text-body-secondary" padding="xl">
  //           No modules available for your account. Contact your administrator.
  //         </Box>
  //       ) : (
  //         <Cards
  //           cardDefinition={{
  //             header: (item) => (
  //               <span
  //                 style={{ cursor: "pointer", color: "#0073bb" }}
  //                 onClick={() => history.push(item.href)}
  //               >
  //                 {item.icon} {item.name}
  //               </span>
  //             ),
  //             sections: [
  //               {
  //                 content: (item) => <Box color="text-body-secondary">{item.description}</Box>,
  //               },
  //             ],
  //           }}
  //           items={cards}
  //           cardsPerRow={[{ cards: 1 }, { minWidth: 600, cards: 2 }, { minWidth: 900, cards: 3 }]}
  //         />
  //       )}
  //     </SpaceBetween>
  //   </ContentLayout>
  // );
}
